import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "common/locales";
import {
  addFilledOut,
  setQuickAssessmentFinished,
  setQuickAssessmentStarted,
  useAppDispatch,
  useAppSelector,
  User,
} from "model";

import { FilloutStandardEmbed } from "@fillout/react";
import {
  NO_PROGRAMM_ID,
  selectQuickAssessmentResultsById,
} from "model/quickAssessmentSlice";
import { useSelector } from "react-redux";
import StepCard from "./FirstStepCard";
import { ProgrammeNameAndText } from "./ProgrammesDetailsDrawer";

export default function NoProgrammeDrawerElement() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.details);
  const quickAssessmentStarted = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
    (state) => (state as any).quickAssessmentStarted
  );
  const onSubmit = () => {
    dispatch(addFilledOut({ filledOutProgrammeId: NO_PROGRAMM_ID }));
    dispatch(setQuickAssessmentFinished(true));
  };

  const quickAssessmentResults = useAppSelector((state) =>
    selectQuickAssessmentResultsById(state, NO_PROGRAMM_ID)
  );
  const hasFilledOutQuickAssessment =
    quickAssessmentResults?.submitted === true;

  const maxHeight = "auto";
  if (isMobile && quickAssessmentStarted.quickAssessmentStarted && user) {
    return <>{isMobile && QuickAssessmentIframe(user, onSubmit)}</>;
  } else if (!hasFilledOutQuickAssessment) {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          p: 3,
          gap: 5,
          flex: 1, // Take remaining space
          flexDirection: "column",
          display: "flex",
          alignItems: "top",
          justifyContent: "top",
          minHeight: "calc(100vh)", // Ensure minimum height even when loading
        }}
      >
        {ProgrammeNameAndText(
          {
            programmeName: "",
            guid: "",
            description: "",
            filloutParameters: {},
            welcomeText: "",
            submitted: false,
          },
          false,
          maxHeight,
          () => {
            //do nothing
          },
          "",
          t("no.programmes.available.body"),
          t,
          false
        )}

        {!quickAssessmentStarted.quickAssessmentStarted &&
          !hasFilledOutQuickAssessment && (
            <StepCard
              stepNumber={1}
              stepTitle="Do a quick assessment"
              stepDescription="The first step is to tell us a bit about your farm."
              buttonText="TELL US ABOUT YOUR FARM"
              daysLeft={122}
              status="In progress"
              onButtonClick={() => {
                dispatch(setQuickAssessmentStarted(true));
              }}
            />
          )}
      </Box>
    );
  } else {
    return ProgrammeNameAndText(
      {
        programmeName: "",
        guid: "",
        description: "",
        filloutParameters: {},

        welcomeText: "",
        submitted: true,
      },
      false,
      maxHeight,
      () => {
        //do nothing
      },
      "",
      t("quick.assessment.thank.you"),
      t,
      false
    );
  }
}
export const QuickAssessmentIframe = (user: User, onSubmit: () => void) => {
  return (
    <FilloutStandardEmbed
      filloutId="f9fYsLghULus"
      onSubmit={onSubmit}
      parameters={{
        userGuid: user?.guid,
        programmeGuid: NO_PROGRAMM_ID,
        email: user?.mail,
      }}
    />
  );
};
